import { createExtensionService } from '@tencent/ark-extensions';
import componentConfig from './component-config';
import { SlideDataServices } from '@src/slide/domain/slide-app/core/slide-data-services.core';
import { IFileCompressionOptions } from './interface';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { getVipInfo } from '@src/js/common/ark-extensions/dc-components/vip-linktext';

export async function invokeFileCompression(options: IFileCompressionOptions) {
    reportFileCompression(options.position);

    const extensionService = createExtensionService();
    await extensionService.scanAndHandleExtensions([componentConfig]);

    const titleManager = SlideDataServices.SlideTitleManager();
    const docInfoManager = SlideDataServices.DocInfoManager();

    const extension = await extensionService.getExtension(componentConfig.name);
    extension.show({
        ...options,
        title: titleManager?.title,
        padId: docInfoManager?.padId,
        mimeType: docInfoManager?.docInfo?.mime_type,
        ext: docInfoManager?.docInfo?.doc_meta?.cos_info?.drive_ext,
        originSize: (docInfoManager?.docInfo?.doc_meta as any)?.size,
        originFolderID: '/',
    });
}

function reportFileCompression(position) {
    tdw({
        module: 'icon_entrance',
        opername: 'doc_vip_fileslim',
        action: 'click',
        ver5: getVipInfo(), // 会员状态
        ver9: position,
    });
}
